import { gsap } from "gsap";

export const menuToggle = function (menuIDs) {
    const checkbox = document.getElementById(menuIDs[0]);
    const menu = document.getElementById(menuIDs[1]);
    const links = document.getElementById(menuIDs[2]);
    const closeClass = menuIDs[3];

    if (!checkbox || !menu || !links || !closeClass) return;

    // console.log(checkbox);
    // console.log(menu);
    // console.log(links);
    // console.log(closeClass);

    // console.log(links);
    // let linkList = document.getElementById(menuIDs[2]).querySelectorAll("li");
    // let linkList = links.getElementsByTagName("li");
    // console.log(linkList);

    let tl = gsap.timeline({ reversed: true, paused: true });

    tl.set(links, { autoAlpha: 0 });
    tl.set(menu, { height: 0, autoAlpha: 1 });
    tl.to(menu, { height: "auto", duration: 0.2 });
    tl.to(links, { duration: 0.5, autoAlpha: 1 });

    // {
    //     duration: 1,
    //     opacity: 0,
    //     y: 20,
    //     stagger: 0.1,
    //     ease: 'expo.inOut',
    // }

    checkbox.addEventListener("change", handleCheckbox);

    // close menu if user clicks anywhere outside the menu
    function handleCheckbox(e) {
        if (checkbox.checked) {
            tl.play();
            addEventListener("click", handler, false);
        } else {
            tl.timeScale(2);
            tl.reverse();
        }
    }

    function handler(e) {
        // console.log(e.target.classList);
        if (
            !menu.contains(e.target) &&
            !e.target.classList.contains(closeClass)
        ) {
            checkbox.click();
            // checkbox.checked = true;
            removeEventListener("click", handler, false);
        }
    }
};
